import { createContext } from 'react'

const GridContext = createContext({
    reloadGrid: () => {},
})

export default GridContext
